/**
 * Encapsulates display modes we showcase (name, how to draw agenda, how to scale maps). 
 * Our perfromance collection holds both TTFB, an PageScore for now.
 */

/**
* Display modes maps support.
*/
let displayModes = {
    ttfb: {
        name: 'ttfb',
        lowered: 'ttfb',
        description: "Time to First Byte (TTFB) in milliseconds"
    },
    sloViolation: {
        name: 'sloViolation',
        lowered: 'sloviolation',
        description: "Service Level Objective violations",
        extraProps: ['under'],
    },
    logcount: {
        name: 'logcount',
        lowered: 'logcount',
        description: "WAF Events",
        extraProps: ['blockcount', 'ratelimitblockcount', 'hits']
    },
    revenue: {
        name: 'revenue',
        lowered: 'revenue',
        description: "Orders Last 15m",
        extraProps: []
    },
    livePageRequests: {
        name: 'livePageRequests',
        lowered: 'livepagerequests',
        description: "Live Page Requests",
        extraProps: []
    },
    opacity: {
        name: 'Opacity',
        lowered: 'opacity',
        description: "Fading out info",
    }
};
displayModes.defaultMode = displayModes.ttfb;

displayModes.findMode = (value, useDefault = true) => {
    const defaultMode = displayModes.defaultMode;
    if (!!!value) {
        return useDefault ? defaultMode : null;
    }
    let requested = value.toLowerCase();
    const ownNames = Object.getOwnPropertyNames(displayModes);
    const knownModes = ownNames.map(name => {
        const value = displayModes[name];
        return (!!value && value.hasOwnProperty('lowered')) ? value : null;
    }).filter(elem => !!elem);

    const result = knownModes.find(mode => mode.lowered == requested);
    return result ? result : (useDefault ? defaultMode : null);
};

displayModes.extract = (args) => {
    let { displayedMode } = args;
    if (!displayedMode)
        throw new Error("No display mode was requested.");

    if (!displayedMode.description) {
        const requested = displayedMode;
        displayedMode = displayModes.findMode(displayedMode.name, false);

        if (!displayedMode) {
            throw new Error(`Display mode was not found by name ${requested.name}`);
        }
    }

    return args.displayedMode = displayedMode;
}

displayModes.assertSupports = (displayedMode, supportedModes) => {
    if (supportedModes instanceof Array) {
        if (!supportedModes.includes(displayedMode)) {
            const modes = [];
            supportedModes.forEach(mode => modes.push(mode.name));
            throw new Error(`${displayedMode.name} is not allowed by map, supported: ${modes.join(', ')}`);
        }
    }
    else if (displayedMode != supportedModes) {
        throw new Error(`${displayedMode.name} is not allowed by map, supported: ${supportedModes.name}`);
    }
}

export default displayModes;
